module.exports = __webpack_public_path__ + "img/computer-classic.eb0051a9.svg";